import angular from 'angular';
angular
  .module('cxSettings')
  .controller('MailTemplateSettingsCtrl', [
    '$state',
    'templateHttpSvc',
    'flySvc',
    'dialogsSvc',
    'companyId',
    'translateListFilter',
    mailTemplateSettingsCtrl,
  ]);
function mailTemplateSettingsCtrl(
  $state,
  templateHttpSvc,
  flySvc,
  dialogsSvc,
  companyId,
  translateListFilter,
) {
  var vm = this;
  vm.search = '';
  vm.context = null;
  vm.languageCode = null;
  vm.templates = [];
  vm.contexts = [];
  vm.languages = [];

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };
  var retrieveTemplates = function(companyId) {
    templateHttpSvc.getTemplates().then(function(templates) {
      vm.templates = templates;
      vm.contexts = [...new Set(templates.map(p => p.context))].sort();
      vm.languages = [
        ...new Set(templates.flatMap(t => t.languages.map(l => l.languageCode))),
      ].sort();

      const filters = JSON.parse(sessionStorage.getItem('MailTemplateSettingsParams')) || {};
      vm.search = filters.search;
      vm.context = filters.context;
      vm.languageCode = filters.languageCode;
    }, showError);
  };
  retrieveTemplates(companyId);
  vm.getLanguages = function(template) {
    return template.languages
      .map(function(lang) {
        return lang.languageCode;
      })
      .join(', ');
  };
  vm.add = function() {
    $state.go('settings.templates.new');
  };
  vm.edit = function(template) {
    $state.go('settings.templates.edit', {
      templateId: template.id,
      companyId: companyId,
    });
  };
  vm.saveFilters = function() {
    sessionStorage.setItem(
      'MailTemplateSettingsParams',
      JSON.stringify({
        context: vm.context,
        search: vm.search,
        languageCode: vm.languageCode,
      }),
    );
  };
  vm.copy = function(template) {
    if (!template || !template.id) return;
    templateHttpSvc.copyTemplate(template.id).then(
      function(response) {
        var newTemplate = response;
        var idx = vm.templates.indexOf(template);
        if (idx >= 0) {
          vm.templates.splice(idx + 1, 0, newTemplate);
        }
        flySvc.success();
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.remove = function(template) {
    if (!template || !template.id) return;
    dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeleteTemplate').then(function() {
      templateHttpSvc.removeTemplate(template.id).then(
        function() {
          var idx = vm.templates.indexOf(template);
          if (idx >= 0) vm.templates.splice(idx, 1);
          flySvc.success();
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
    });
  };
  vm.contextChanged = () => {
    if (vm.context) {
      vm.context = parseInt(vm.context);
    } else {
      vm.context = undefined;
    }
    vm.saveFilters();
  };

  vm.applyFilters = value => {
    if ((vm.context || vm.context === 0) && value.context !== vm.context) return false;
    if (
      !!vm.search &&
      value.name.toUpperCase().indexOf(vm.search.toUpperCase()) < 0 &&
      translateListFilter(value.id, 'template', value.name)
        .toUpperCase()
        .indexOf(vm.search.toUpperCase()) < 0
    )
      return false;

    if (vm.languageCode && !value.languages.some(x => x.languageCode === vm.languageCode))
      return false;
    return true;
  };
}
